import { render, staticRenderFns } from "./SuitePackageForm.vue?vue&type=template&id=1a5503dc&"
import script from "./SuitePackageForm.vue?vue&type=script&lang=js&"
export * from "./SuitePackageForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports